<owl-carousel-o [options]="optionsDefault">
  <ng-container *ngFor="let of of ofertaPDF; let i = index">
    <ng-template carouselSlide>
      <a [href]="of.urlarchivo" target="_blank"><img class="a-img" [src]="of.urlimagen" [alt]="'Oferta '+i"></a>
    </ng-template>
  </ng-container>
</owl-carousel-o>


